import { CoherenceTheme } from "@coherence-design-system/styles";
import { loadTheme } from "@fluentui/react";
import { createRoot } from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

import { initializeIcons } from "@fluentui/react/lib/Icons";
import App, { msalInstance } from "./App";

const isResizeObserverLoopWarning = (value) => {
  const message = typeof value === "string" ? value : value?.message;
  if (!message) return false;
  return message.includes("ResizeObserver loop") || message.includes("undelivered notifications");
};

// Ignore known browser ResizeObserver loop warning that can be emitted during dropdown measurements in dev.
window.addEventListener("error", (event) => {
    if (isResizeObserverLoopWarning(event?.message) || isResizeObserverLoopWarning(event?.error)) {
      event.preventDefault();
    }
});

window.addEventListener("unhandledrejection", (event) => {
    if (isResizeObserverLoopWarning(event?.reason)) {
      event.preventDefault();
    }
});

initializeIcons(/* Optional base url */);
/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 * MSAL Browser v3.x requires explicit initialization before any API calls
 */

loadTheme(CoherenceTheme);

const rootElement = document.getElementById("root");
if (rootElement) {
  // Initialize MSAL before rendering the app to prevent BrowserAuthError
  msalInstance.initialize().then(() => {
    createRoot(rootElement).render(<App />);
  });
} else {
  console.error("Failed to find the root element");
}

// If you want to start measuring performance in your app, pass a function
// To log results (for example: reportWebVitals(console.log))
// Or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
